module.exports = __webpack_public_path__ + "img/960.5988ac4c.jpg";